// extracted by mini-css-extract-plugin
module.exports = {"opaqueBackground":"styles_opaqueBackground__1Tc-y","container":"styles_container__1d-g8","content":"styles_content__1xiES","dots":"styles_dots__3Iqa6"};